import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import {Field, reduxForm, change} from 'redux-form';

import {clearField} from 'utils/forms';
import {required} from 'utils/validators';
import FormField from 'components/FormField';
import Label from 'components/Label';
import ErrorBlock from 'components/ErrorBlock';
import {
  SelectField,
  TextField,
  TextAreaField,
  DropzoneField
} from 'components/Fields';
import Dropzone from 'components/Dropzone';

import {uploadFile, ACCEPTED_FILE_TYPES} from 'ducks/files';
import {MODALS, fetchLegacyTypes, createLegacyDocument} from 'ducks/bookings';
import {storeDataInModal, selectModal} from 'ducks/modals';
import {legacyDocumentSign} from 'sdk/bookings';

import './styles.css';

const formSubmit = (values, dispatch, props) => {
  const {bookingId} = props;
  const extraActions = props.getExtraActions();

  const data = {
    identifier: values.legacyDocument,
    legacyType: values.legacyType.value,
    title: values.title,
    notes: _.get(values, 'notes', ''),
    booking: bookingId
  };

  dispatch(createLegacyDocument(data, extraActions));
};

const constructLegacyTypeSelectizeOption = legacyType => ({
  value: legacyType.id,
  label: legacyType.name
});

class LegacyDocumentUploadForm extends React.Component<any> {
  state = {
    files: []
  };

  componentDidMount() {
    this.props.fetchLegacyTypes(
      this.props.storeDataExtraActions(data => ({legacyTypes: data}))
    );
  }

  removeFile = () =>
    this.setState({files: []}, () =>
      clearField(this, {field: 'legacyDocument'})
    );

  onFileDrop = files => {
    const storeIdentifierAction = identifier =>
      change('legacyDocumentUpload', 'legacyDocument', identifier);

    const startUploadingAction = () =>
      storeDataInModal({
        modalName: MODALS.LEGACY_DOCUMENT_UPLOAD,
        data: {
          uploading: true
        }
      });

    const finishUploadingAction = () =>
      storeDataInModal({
        modalName: MODALS.LEGACY_DOCUMENT_UPLOAD,
        data: {
          uploading: false
        }
      });

    const file = files[0];
    const signSdk = legacyDocumentSign;
    const signData = {
      filename: file.name,
      fileType: file.type,
      owner: this.props.agreementUserId
    };
    this.setState({files: files}, () =>
      this.props.uploadFile({
        file,
        signSdk,
        signData,
        startUploadingAction,
        finishUploadingAction,
        storeIdentifierAction
      })
    );
  };

  render() {
    const {error, legacyTypes, uploading} = this.props;
    const {files} = this.state;

    return (
      <div className="LegacyDocumentUploadForm">
        <form>
          {error && <ErrorBlock>{error}</ErrorBlock>}
          <div className="mainContainer">
            <div className="innerContainer">
              <FormField>
                <Label>Title</Label>
                <Field name="title" component={TextField} />
              </FormField>
              <FormField>
                <Label>Legacy Type</Label>
                <Field
                  name="legacyType"
                  validate={[required]}
                  component={SelectField}
                  options={legacyTypes.map(legacyType =>
                    constructLegacyTypeSelectizeOption(legacyType)
                  )}
                  disabled={legacyTypes.length === 1}
                />
              </FormField>
              <FormField className="notes">
                <Label>Notes</Label>
                <Field name="notes" component={TextAreaField} />
              </FormField>
            </div>
            <FormField className="innerContainer document">
              <Label>Document</Label>
              <Field
                name="legacyDocument"
                validate={[required]}
                component={DropzoneField}
                onFileDrop={this.onFileDrop}
                removeFile={this.removeFile}
                multiple={false}
                uploading={uploading}
                files={files}
                acceptedFileTypes={ACCEPTED_FILE_TYPES}
                previewType={Dropzone.LARGE}
              />
            </FormField>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {booking} = state.bookings.detail;
  const {data: {uploading, legacyTypes}} = selectModal(
    state,
    MODALS.LEGACY_DOCUMENT_UPLOAD
  );
  let legacyType: any = null;

  const tenants = _.get(booking, 'tenants', []);
  const primaryTenant = _.get(tenants.filter(t => t.isPrimary === true), '0');

  if (!_.isEmpty(legacyTypes)) {
    legacyType = constructLegacyTypeSelectizeOption(legacyTypes[0]);
  }

  return {
    initialValues: {legacyType},
    uploading,
    legacyTypes: legacyTypes || [],
    bookingId: _.get(booking, 'id', null),
    agreementUserId: _.get(primaryTenant, 'agreementUserId')
  };
};
const mapDispatchToProps = {uploadFile, fetchLegacyTypes, createLegacyDocument};
const legacyDocumentUploadForm = reduxForm({
  form: 'legacyDocumentUpload',
  onSubmit: formSubmit,
  enableReinitialize: true
})(LegacyDocumentUploadForm);

export default connect(mapStateToProps, mapDispatchToProps)(
  legacyDocumentUploadForm
);
